// extracted by mini-css-extract-plugin
module.exports = {"container":"GetStartedHeader_container__2rh5m","title":"GetStartedHeader_title__2HBCZ","pagination":"GetStartedHeader_pagination__20PsE"};